var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.462,
    height: 33.461,
    viewBox: "0 0 33.462 33.461",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12783",
    "data-name": "Group 12783",
    transform: "translate(-565 -1404)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3837",
    "data-name": "Group 3837",
    transform: "translate(565.984 1415.81)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1414",
    "data-name": "Rectangle 1414",
    width: 31.494,
    height: 1.968
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3839",
    "data-name": "Group 3839",
    transform: "translate(565 1407.937)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M-51.347,588.275H-79.691a2.562,2.562,0,0,1-2.559-2.559V561.309a2.562,2.562,0,0,1,2.559-2.559h3.149v1.969h-3.149a.591.591,0,0,0-.591.59v24.407a.591.591,0,0,0,.591.591h28.344a.591.591,0,0,0,.591-.591V561.309a.591.591,0,0,0-.591-.59H-54.5V558.75h3.149a2.562,2.562,0,0,1,2.559,2.559v24.407A2.562,2.562,0,0,1-51.347,588.275Z",
    transform: "translate(82.25 -558.75)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3840",
    "data-name": "Group 3840",
    transform: "translate(587.045 1404)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M-47.558,562.017H-54.25v-6.5a1.774,1.774,0,0,1,1.772-1.772h3.149a1.774,1.774,0,0,1,1.772,1.772Zm-4.724-1.968h2.756v-4.33h-2.756Z",
    transform: "translate(54.25 -553.75)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3841",
    "data-name": "Group 3841",
    transform: "translate(569.725 1404)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M-69.558,562.017H-76.25v-6.5a1.774,1.774,0,0,1,1.772-1.772h3.149a1.774,1.774,0,0,1,1.772,1.772Zm-4.724-1.968h2.756v-4.33h-2.756Z",
    transform: "translate(76.25 -553.75)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3842",
    "data-name": "Group 3842",
    transform: "translate(577.008 1421.321)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1416",
    "data-name": "Rectangle 1416",
    width: 3.149,
    height: 1.968
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3843",
    "data-name": "Group 3843",
    transform: "translate(583.307 1421.321)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1417",
    "data-name": "Rectangle 1417",
    width: 3.149,
    height: 1.968
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3844",
    "data-name": "Group 3844",
    transform: "translate(589.604 1421.321)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1418",
    "data-name": "Rectangle 1418",
    width: 3.149,
    height: 1.968
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3845",
    "data-name": "Group 3845",
    transform: "translate(570.709 1425.258)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1419",
    "data-name": "Rectangle 1419",
    width: 3.149,
    height: 1.968
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3846",
    "data-name": "Group 3846",
    transform: "translate(577.008 1425.258)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1420",
    "data-name": "Rectangle 1420",
    width: 3.149,
    height: 1.968
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3847",
    "data-name": "Group 3847",
    transform: "translate(583.307 1425.258)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1421",
    "data-name": "Rectangle 1421",
    width: 3.149,
    height: 1.968
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3848",
    "data-name": "Group 3848",
    transform: "translate(589.604 1425.258)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1422",
    "data-name": "Rectangle 1422",
    width: 3.149,
    height: 1.968
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3849",
    "data-name": "Group 3849",
    transform: "translate(570.709 1429.194)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1423",
    "data-name": "Rectangle 1423",
    width: 3.149,
    height: 1.968
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3850",
    "data-name": "Group 3850",
    transform: "translate(577.008 1429.194)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1424",
    "data-name": "Rectangle 1424",
    width: 3.149,
    height: 1.968
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3851",
    "data-name": "Group 3851",
    transform: "translate(583.307 1429.194)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1425",
    "data-name": "Rectangle 1425",
    width: 3.149,
    height: 1.968
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3838",
    "data-name": "Group 3838",
    transform: "translate(575.432 1407.937)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1415",
    "data-name": "Rectangle 1415",
    width: 12.597,
    height: 1.968
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.83452d5da6c19450e467226886538067.svg";
export { ForwardRef as ReactComponent };